export default __webpack_public_path__ + "static/media/1889.df6f642e.png";